module.exports = __webpack_public_path__ + "media/Schamanz_loop_1600.48e8909e.mp4";